import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faDiagramProject, faLock } from '@fortawesome/free-solid-svg-icons';
import { Tooltip } from '@framework/ui/atoms/Tooltip';
import { useTranslation } from 'react-i18next';

type Props = {
  viewModelName: string;
  isLocked: boolean;
};

/**
 * グループライセンスによる制限がかかっているビューモデルのタイトル表示コンポーネント
 * - 遷移なし（Linkではなくdiv）
 * - グレーのアイコン・テキスト
 * - cursor-not-allowed
 * - ツールチップで制限メッセージを表示
 */
export const RestrictedViewModelItemTitle: React.FC<Props> = ({ viewModelName, isLocked }: Props) => {
  const { t } = useTranslation();
  return (
    <Tooltip tooltip={t('sidebar.restrictedItem.tooltip.license')} placement="right">
      <div className="flex min-w-0 cursor-not-allowed items-center rounded-sm py-1 pr-1">
        <span className="fa-layers fa-fw mr-1 shrink-0 text-gray-400">
          <FontAwesomeIcon icon={faDiagramProject} />
        </span>
        {isLocked && (
          <span className="fa-layers fa-fw mr-1 shrink-0 text-gray-400">
            <FontAwesomeIcon icon={faLock} />
          </span>
        )}
        <span className="truncate text-gray-400">{viewModelName}</span>
      </div>
    </Tooltip>
  );
};
